import styles from './styles.module.scss'

import { Card, Button, Input } from 'antd';

import { useContext, useState } from 'react';

import { UserContext } from '@/context/user';
import { setUserContextItem, removeUserContextItem } from '@/persistence/user_context';

export const GoogleTagManagerAttribute = ({ onDone }: AttributeInput) => {
  const { tagManagerAttr, setTagManagerAttr } = useContext(UserContext)
  const [value, setValue] = useState<string>('')

  const onInputChange = (e: any) => {
    setValue(e.target.value)
  }

  const onReset = () => {
    removeUserContextItem({ key: 'tag_manger_id' })
    setTagManagerAttr(undefined)
  }

  const onSet = () => {
    setUserContextItem({ key: 'tag_manger_id', value })
    setTagManagerAttr({ id: value })
  }

  const headStyle = {
    backgroundColor: '#fff1f0'
  }

  const bodyMinHeightStyle = {
    minHeight: '160px'
  }

  const bodyStyle = {
    backgroundColor: '#fff1f0',
    ...bodyMinHeightStyle,
  }

  return (
    <Card
      title="구글 태그매니저 ID"
      headStyle={!tagManagerAttr ? headStyle : {}}
      bodyStyle={!tagManagerAttr ? bodyStyle : bodyMinHeightStyle }
      bordered={true}>
      {
        (tagManagerAttr && tagManagerAttr.id) && (
          <>
            <div className={styles.rowInput}>
              <Input size="large" value={tagManagerAttr.id} disabled={true} />
            </div>
            <div className={styles.rowButton}>
              <Button type="dashed" danger onClick={(e) => onReset() }>초기화하기</Button>
            </div>
          </>
        )
      }
      {
        (!tagManagerAttr || !tagManagerAttr.id) && (
          <>
            <div className={styles.rowInput}>
              <Input size="large" placeholder="구글 태그매니저 ID를 입력해주세요" onChange={(e) => onInputChange(e) } />
            </div>
            <div className={styles.rowButton}>
              <Button type="primary" onClick={(e) => onSet() }>설정하기</Button>
            </div>
          </>
        )
      }
    </Card>
  )
}
